import Slug, { getServerSideProps } from './[...slug]';

export default Slug;
export { getServerSideProps };
